module.exports = __webpack_public_path__ + "static/media/LogoTech.dbfebc7b.svg";